import { render, staticRenderFns } from "./LinkRe.vue?vue&type=template&id=2dca9338&scoped=true&"
import script from "./LinkRe.vue?vue&type=script&lang=ts&"
export * from "./LinkRe.vue?vue&type=script&lang=ts&"
import style0 from "./LinkRe.vue?vue&type=style&index=0&id=2dca9338&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dca9338",
  null
  
)

export default component.exports